import { Flex, Text } from '@chakra-ui/react'
import moment from 'moment'

const defaultFormatDate = (date?: Date | null) =>
  moment(date).format('MMM Do YYYY')

export const DatePickerTrigger = ({
  startDate,
  endDate,
  formatDate = defaultFormatDate,
}: {
  startDate: Date | null | undefined
  endDate: Date | null | undefined
  formatDate?: (date?: Date | null) => string
}) => {
  const start = formatDate(startDate)
  const end = formatDate(endDate)
  return (
    <Flex
      bg='white'
      className='dateRange'
      border={'1px'}
      borderColor={'gray.200'}
      h={8}
      position={'relative'}
      px={2}
      alignItems={'center'}
      py={1}
      borderRadius={'sm'}
    >
      {startDate || endDate ? (
        <Text fontSize={'xs'} color={'gray.800'} fontWeight={'semibold'}>
          {start} - {end}
        </Text>
      ) : (
        <Text fontSize={'xs'} color={'gray.800'} fontWeight={'semibold'}>
          Time Range
        </Text>
      )}
    </Flex>
  )
}
